import styled from 'styled-components';
import { devices } from '../../styles/viewports.styles';
import { LayoutType } from '../../types';
export const MessagingContentHolder = styled.div.withConfig({
  displayName: "MessageContainerstyles__MessagingContentHolder",
  componentId: "e13ym6-0"
})(["width:100%;text-align:center;@media ", "{width:450px;overflow:visible;}"], devices.desktop);
export const FlowStepMessage = styled.div.withConfig({
  displayName: "MessageContainerstyles__FlowStepMessage",
  componentId: "e13ym6-1"
})(["display:grid;align-content:center;", " @media ", "{margin:0 auto;}"], props => props.layoutType !== LayoutType.FramedCentredStep && `  margin: 2rem auto;`, devices.desktop);